import React from "react";
import "./Blogs.css";
import Header_Banner from "../common-components/common_banner/header_banner/Header_Banner";
import Blog_Cards from "../common-components/common_card/blog_cards/Blog_Cards";
import { Col, Container, Row } from "react-bootstrap";
import Complete_Medical from "../common-components/common_banner/complete_medical/Complete_Medical";

const Blogs = () => {
  const breadcrumbs = [
    { label: "Home", link: "/about-us", isActive: false },
    { label: "BLOGS", link: "", isActive: true },
  ];

  const blogPosts = [
    {
      id: 1,
      date: "08 October, 2025",
      title: "DG Shipping Medical Requirements: What Every Seafarer Must Know",
      description:
        "A complete and simplified guide to help seafarers understand DG Shipping– approved medical examinations before joining a vessel.",
      img: "/assets/images/blogs/blog-img-1.png",
    },
    {
      id: 2,
      date: "09 October, 2025",
      title: "Top 5 Health Issues Faced by Seafarers — And How to Prevent Them",
      description:
        "Discover the most common health challenges at sea and simple preventive strategies recommended by maritime medical experts.",
      img: "/assets/images/blogs/blog-img-2.png",
    },
    {
      id: 3,
      date: "10 October, 2025",
      title: "A Complete Checklist for Your Pre-Joining Medical Examination ",
      description:
        "A quick and practical checklist to help seafarers prepare for their medical examination without stress or delays.",
      img: "/assets/images/blogs/blog-img-3.png",
    },

    {
      id: 4,
      date: "08 October, 2025",
      title: "DG Shipping Medical Requirements: What Every Seafarer Must Know",
      description:
        "A complete and simplified guide to help seafarers understand DG Shipping– approved medical examinations before joining a vessel.",
      img: "/assets/images/blogs/blog-img-1.png",
    },
    {
      id: 5,
      date: "09 October, 2025",
      title: "Top 5 Health Issues Faced by Seafarers — And How to Prevent Them",
      description:
        "Discover the most common health challenges at sea and simple preventive strategies recommended by maritime medical experts.",
      img: "/assets/images/blogs/blog-img-2.png",
    },
    {
      id: 6,
      date: "10 October, 2025",
      title: "A Complete Checklist for Your Pre-Joining Medical Examination ",
      description:
        "A quick and practical checklist to help seafarers prepare for their medical examination without stress or delays.",
      img: "/assets/images/blogs/blog-img-3.png",
    },

    {
      id: 7,
      date: "08 October, 2025",
      title: "DG Shipping Medical Requirements: What Every Seafarer Must Know",
      description:
        "A complete and simplified guide to help seafarers understand DG Shipping– approved medical examinations before joining a vessel.",
      img: "/assets/images/blogs/blog-img-1.png",
    },
    {
      id: 8,
      date: "09 October, 2025",
      title: "Top 5 Health Issues Faced by Seafarers — And How to Prevent Them",
      description:
        "Discover the most common health challenges at sea and simple preventive strategies recommended by maritime medical experts.",
      img: "/assets/images/blogs/blog-img-2.png",
    },
    {
      id: 9,
      date: "10 October, 2025",
      title: "A Complete Checklist for Your Pre-Joining Medical Examination ",
      description:
        "A quick and practical checklist to help seafarers prepare for their medical examination without stress or delays.",
      img: "/assets/images/blogs/blog-img-3.png",
    },
  ];

  return (
    <>
      <Header_Banner
        imgSrc={"assets/images/shore-blogs/shore_banner.png"}
        title_text="Blogs"
        breadcrumbs={breadcrumbs}
      />
      <section className="blogs_section">
        <Container>
          <Row>
            {blogPosts.map((post) => (
              <Col key={post.id} md={4} sm={6} xs={12} className="mb-4">
                <Blog_Cards
                  img={post.img}
                  title={post.title}
                  date={post.date}
                  description={post.description}
                  id={post.id}
                />
              </Col>
            ))}
          </Row>
        </Container>
        <Complete_Medical />
      </section>
    </>
  );
};

export default Blogs;
